import { SupabaseClientService } from 'src/services';
import { taptapCustomerField } from './constants/taptap-fields';

const TAPTAP_DEFAULT_CREATED_AT_FROM = '2026-04-01T00:00:00+08:00';

//fetch all customers data
export const taptapFetchCustomers = ({
  includeDefaultCreatedAtFilters = true
}: {
  includeDefaultCreatedAtFilters?: boolean;
} = {}) => {
  let query = SupabaseClientService.from('customers')
    .select(`*, customers_payments(*)`, { count: 'exact' })
    .filter('is_deleted', 'eq', false)
    .filter('customers_payments.is_deleted', 'eq', false);

  if (includeDefaultCreatedAtFilters) {
    query = query
      .gte(taptapCustomerField.CREATED_AT, TAPTAP_DEFAULT_CREATED_AT_FROM)
      .lte(taptapCustomerField.CREATED_AT, new Date().toISOString());
  }

  return query;
};

export const taptapGetProfiles = async () =>
  SupabaseClientService.from('profiles')
    .select('*')
    .order('display_name', { ascending: true });

export const taptapGetCustomerDetailsService = async (id: number) =>
  SupabaseClientService.from('customers')
    .select(`*, customers_payments(*)`)
    .eq('id', id)
    .filter('customers_payments.is_deleted', 'eq', false)
    .order('created_at', {
      ascending: true,
      referencedTable: 'customers_payments'
    });

export const taptapGetCustomerDetailsViaTransactionNo = async (
  transactionNo: string
) =>
  SupabaseClientService.from('customers')
    .select()
    .filter('is_deleted', 'eq', false)
    .filter(taptapCustomerField.INTERNAL_TRANSACTION_NO, 'eq', transactionNo); // INTENDED TO BE NOT SINGLE()

export const taptapUpdateCustomerViaId = (id: number, newData: any) =>
  SupabaseClientService.from('customers')
    .update({
      ...newData,
      completed_at:
        newData.status === 'COMPLETED' ? new Date().toISOString() : null
    })
    .eq('id', id)
    .select();

export const taptapFetchCustomerAuditService = (id: number) => {
  return SupabaseClientService.schema('audit')
    .from('record_version')
    .select(`*`)
    .eq('table_schema', 'public')
    .or(`table_name.eq.customers,table_name.eq.customers_payments`)
    .or(`record->>id.eq.${id},old_record->>id.eq.${id}`)
    .order('ts', { ascending: false });
};

export const taptapFetchEODReport = () => {
  return SupabaseClientService.from('eod_customer_report').select(`*`);
};

export const taptapCreateTicketLogs = (payload: {
  ticket_id: number;
  status: string;
  updated_by?: string;
}) => {
  return SupabaseClientService.from('ticket_logs').insert({
    ticket_id: payload.ticket_id,
    status: payload.status,
    updated_by: payload.updated_by
  });
};

//GET TICKET LOGS FOR A CUSTOMER HISTORY
export const taptapFetchCustomerTimeline = (customerId: number) => {
  return SupabaseClientService.from('ticket_logs')
    .select('*')
    .eq('ticket_id', customerId)
    .order('created_at', { ascending: true });
};

//Fetch by status
export const fetchTicketLogsByStatuses = (statuses: string[]) => {
  return SupabaseClientService.from('ticket_logs')
    .select('*')
    .in('status', statuses)
    .order('created_at', { ascending: true });
};

//Fetch comment
export const fetchTicketViaCustomerIdComment = (
  customerId: number,
  options?: { limit?: number; beforeCreatedAt?: string }
) => {
  let query = SupabaseClientService.from('ticket_comments')
    .select('*')
    .eq('customer_id', customerId);

  if (options?.beforeCreatedAt) {
    query = query.lt('created_at', options.beforeCreatedAt);
  }

  query = query.order('created_at', { ascending: false });

  if (options?.limit) {
    query = query.limit(options.limit);
  }

  return query;
};

export const addTicketComment = (payload: {
  customer_id: number;
  user_id?: number;
  full_name?: string;
  img_url?: string;
  comment?: string;
  tag?: string;
}) => {
  return SupabaseClientService.from('ticket_comments')
    .insert({
      customer_id: payload.customer_id,
      user_id: payload.user_id,
      full_name: payload.full_name,
      img_url: payload.img_url,
      comment: payload.comment,
      tag: payload.tag
    })
    .select()
    .single();
};

export const updateTicketComment = (payload: {
  comment_id: number;
  customer_id: number;
  updated_at?: string;
  img_url?: string | null;
  comment?: string;
}) => {
  return SupabaseClientService.from('ticket_comments')
    .update({
      customer_id: payload.customer_id,
      updated_at: payload.updated_at || new Date().toISOString(),
      comment: payload.comment,
      img_url: payload.img_url
    })
    .eq('id', payload.comment_id)
    .eq('customer_id', payload.customer_id)
    .select()
    .single();
};

export const deleteTicketComment = (payload: {
  customer_id: number;
  comment_id: number;
}) => {
  return SupabaseClientService.from('ticket_comments')
    .update({ deleted_at: new Date().toISOString() })
    .eq('id', payload.comment_id)
    .eq('customer_id', payload.customer_id)
    .select()
    .single();
};
